import React from 'react';

import { Container, Links, Link, HelpBtn, Content } from './style';

export default function Footer() {
  return (
    <Container>
      <Content>
        {/* <Links>
          <Link href='#'>Mindi</Link>
          <Link href='#'>Indique</Link>
        </Links>
        <HelpBtn href='#'>Ajuda</HelpBtn> */}
        <HelpBtn target='_blank' href='https://wa.me/555591211888'>Ajuda</HelpBtn>
      </Content>
    </Container>
  );
}
